import { Box,
    DialogTitle as MuiDialogTitle, IconButton,
    Typography } from '@mui/material';
import { styled } from '@mui/system';

import { colors } from '../../../../theme';

export const dialogPaperProps = {
    style: {
        backgroundColor: colors.darkBlue,
        color: colors.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '600px',
        maxHeight: '90vh',
        overflowY: 'auto' as const
    }
};

export const DialogTitle = styled(MuiDialogTitle)({
    textAlign: 'center',
    fontWeight: 'bold'
});

export const ApproveDialogContent = styled(Box)({
    paddingTop: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
});

export const AttachmentUploadWrapper = styled(Box)({
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '& > div': {
        width: '100% !important',
        maxWidth: '100% !important',
        boxSizing: 'border-box',
        paddingLeft: '0px !important'
    },
    '& label': {
        maxWidth: '100% !important',
        width: '100% !important',
        paddingLeft: '0px !important'
    },
    '& *': {
        maxWidth: '100%',
        boxSizing: 'border-box'
    }
});

export const ApproveDialogDescription = styled(Typography)({
    color: colors.white,
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '10px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const ApproveDialogButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '20px',
    width: '100%',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const ApproveDialogCloseButton = styled(IconButton)({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: colors.white,
    '&:hover': {
        backgroundColor: colors.darkGray
    }
});

